import React from 'react';
export const Solution = () => {
  return <div className="w-full bg-white py-12 Solution" data-id="element-155">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-156">
        <h2 className="text-2xl md:text-3xl font-bold text-blue-900 text-center mb-8" data-id="element-157">
          Brighten Your Dog's Teeth & Freshen Their Breath - With This New, Easy
          Yet Fast Solution
        </h2>
        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-158">
          <div className="md:w-1/2" data-id="element-159">
            <p className="text-gray-700 mb-6" data-id="element-160">
              If you've been struggling with your dog's bad breath, trying mint
              treats, dental chews, or even attempting to brush their teeth
              (good luck with that!), there's now a revolutionary approach that
              tackles the problem at its source. Instead of just masking the
              odor or scrubbing the surface, this solution works from the inside
              out by:
            </p>
            <ul className="space-y-3 mb-6" data-id="element-161">
              <li className="flex items-start" data-id="element-162">
                <span className="text-amber-600 mr-2" data-id="element-163">✓</span>
                <span data-id="element-164">Rebalancing your dog's gut microbiome</span>
              </li>
              <li className="flex items-start" data-id="element-165">
                <span className="text-amber-600 mr-2" data-id="element-166">✓</span>
                <span data-id="element-167">Reducing sulfur-producing bacteria</span>
              </li>
              <li className="flex items-start" data-id="element-168">
                <span className="text-amber-600 mr-2" data-id="element-169">✓</span>
                <span data-id="element-170">Supporting healthy digestion</span>
              </li>
              <li className="flex items-start" data-id="element-171">
                <span className="text-amber-600 mr-2" data-id="element-172">✓</span>
                <span data-id="element-173">Naturally freshening breath from within</span>
              </li>
            </ul>
            <p className="text-gray-700 font-bold mb-6" data-id="element-174">
              And the best part? It takes just 30 seconds a day, and dogs
              actually think it's a treat!
            </p>
            <button className="bg-amber-600 text-white font-semibold py-3 px-6 rounded-full hover:bg-amber-500 transition" onClick={() => {
            document.querySelector('.Science')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-175">
              Learn More
            </button>
          </div>
          <div className="md:w-1/2" data-id="element-176">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1pG4EFyr5zznoPGS18K4RL/Image_fx_%289%29.jpg" alt="Dog supplement product" className="rounded-lg shadow-md w-full" data-id="element-177" />
          </div>
        </div>
      </div>
    </div>;
};